<template>
  <div :class="[`rarity-${rarity}`, {highlight: checked&&!purchased}]" class="itemobj-avatar">
    <img :src="image" class="itemobj-img" />
    <span class="itemobj-num" v-show="num>1">X{{num}}</span>
    <div :class="{checked:checked||purchased}" class="itemobj-checkbox" v-show="showCheck"></div>
  </div>
</template>
<script>
  export default {
    name: 'Item',
    props: {
      image: String,
      num: Number,
      rarity: Number,
      checked: Boolean,
      purchased: Boolean,
      showCheck: {
        type: Boolean,
        default: true
      }
    }
  }
</script>
<style lang="scss">
  .itemobj-avatar {
    position: relative;
    margin: 0 auto;
    @include flexrc;
    @include px2res(width, 104);
    @include px2res(height, 105);
    @include px2res(padding, 13%);
    @include bgc;
    &.highlight {
      animation: item_breath infinite alternate .7s linear;
    }
  }
  .itemobj-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .itemobj-num {
    position: absolute;
    @include px2res(bottom, 10);
    @include px2res(right, 12);
    @include px2res(font-size, 26);
    font-family: $teko-font-family;
    color: #fff;
  }
  .itemobj-checkbox {
    position: absolute;
    @include px2res(bottom, 13);
    @include px2res(left, 15);
    @include px2res(width, 19);
    @include px2res(height, 20);
    &.checked::after {
      content: '';
      position: absolute;
      display: block;
      @include px2res(bottom, 0);
      @include px2res(left, -4);
      @include px2res(width, 29);
      @include px2res(height, 22);
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/item/item.vue